import Link from "next/link";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";

interface GridCtaCardProps {
  copy: string;
}

export const GridCtaCard = ({ copy }: GridCtaCardProps) => {
  return (
    <div
      className={cn(
        "relative flex flex-col items-center overflow-hidden",
        "justify-end py-8",
        "lg:py-24",
        "h-[32rem] gap-4 lg:h-[40rem]",
        "rounded-2xl bg-black shadow-xl",
      )}
    >
      <div
        className={cn(
          "flex flex-col items-center justify-center gap-4 lg:justify-end",
        )}
      >
        <div className="px-4 text-center text-2xl font-black text-white">
          {copy}
        </div>
        <Button
          className="z-50 bg-white text-base text-black hover:bg-gray-100"
          size="lg"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          Start Dressing Better
        </Button>

        <Link
          className="-mt-2 px-4 text-center text-sm text-white hover:underline"
          href="/"
        >
          Learn More
        </Link>
      </div>
      <div className="pointer-events-none absolute right-2 top-2 w-full max-w-full select-none space-y-2 text-7xl font-black tracking-wider text-gray-50 text-opacity-[0.05]">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            style={{
              opacity: `${1 - i / 12}`,
              WebkitTextStroke:
                i === 3
                  ? "1px rgba(255, 255, 255, 0.3)"
                  : "1px rgba(255, 255, 255, 0.1)",
            }}
            className="w-full text-center"
          >
            GLIMPSES
          </div>
        ))}
      </div>
    </div>
  );
};
